export const periods = [
  {
    label: 'Week',
    value: 'weekly',
  },
  {
    label: 'Month',
    value: 'pastMonth',
  },
  {
    label: 'Quarter',
    value: 'past3Months',
  },
  {
    label: 'Year',
    value: 'past12Months',
  },
  {
    label: 'All',
    value: 'all',
  },
];
